import React, { useId } from 'react';
import './AudioGainSlider.css';
import { useTranslation } from 'react-i18next';

function AudioGainSlider({
  gain,
  setGain,
  disabled,
}: {
  gain: number;
  setGain: React.Dispatch<React.SetStateAction<number>>;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  const sliderId = `gain-slider-${useId()}`;
  const percent = (gain * 100).toFixed(0);

  return (
    <div>
      <label htmlFor={sliderId}>
        {t("Gain")}: {percent}%
      </label>
      <input
        id={sliderId}
        type="range"
        min="0"
        max="1"
        step="0.01"
        disabled={disabled}
        value={gain}
        onChange={(e) => setGain(parseFloat(e.target.value))}
        aria-valuemin={0}
        aria-valuemax={1}
        aria-valuenow={gain}
        aria-valuetext={`${percent}%`}
        aria-label={t("Gain slider")}
      />
    </div>
  );
}

export default AudioGainSlider;
